/** Typed implant dates: MM/DD/YYYY, MM-DD-YYYY, or YYYY-MM-DD. */
export const parseImplantDate = (input?: string | null): Date | null => {
  if (!input || input.trim() === '-') return null;
  const text = input.trim();
  const us = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  const year = us ? Number(us[3]) : iso ? Number(iso[1]) : NaN;
  const month = us ? Number(us[1]) : iso ? Number(iso[2]) : NaN;
  const day = us ? Number(us[2]) : iso ? Number(iso[3]) : NaN;
  if (!year || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
};
